import React, { useEffect, useState } from 'react'
import { useAboutUsStore } from '../../store/useAboutUs'
import Loader from '../../Components/Loader'
import { useNavigate } from 'react-router'

const Ourpromise = () => {
  const [data, setData] = useState({
    subTitle: '',
    title: '',
    description: '',
    images: []
  })

  const { promise, postPromise } = useAboutUsStore()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (promise) {
      setData({
        subTitle: promise?.subTitle || '',
        title: promise?.title || '',
        description: promise?.description || '',
        images: promise?.images || [],
        buttonText: promise?.buttonText || ''
      })
    }
  }, [promise])

  const getImageSrc = (img) => {
    if (!img) return null;
    if (typeof img === "string") {
      return img;
    }
    return URL.createObjectURL(img);
  };


  const handleChange = (e) => {
    const { name, value } = e.target
    setData((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async () => {
    setLoading(true)
    await postPromise(data)
    setLoading(false)
  }

  return (
    <div id="story-section" className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6">
      <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
        <h3>Our Promise</h3>
      </div>
      <Loader loading={loading}>
        <div className="p-6">
          <div className="grid grid-cols-1 gap-6">
            <div>
              <label className="block text-sm text-neutral-700 mb-2">Section SubTitle</label>
              <input
                type="text"
                name="subTitle"
                value={data.subTitle}
                onChange={handleChange}
                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
              />

              <label className="block text-sm text-neutral-700 mb-2">Section Title</label>
              <input
                type="text"
                name="title"
                value={data.title}
                onChange={handleChange}
                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
              />

              <label className="block text-sm text-neutral-700 mb-2">Button Text</label>
              <input
                type="text"
                name="buttonText"
                value={data.buttonText}
                onChange={handleChange}
                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
              />

              <label className="block text-sm text-neutral-700 mb-2">Description</label>
              <textarea
                rows="8"
                name="description"
                value={data.description}
                onChange={handleChange}
                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400"
              />
            </div>

            <div className="grid grid-cols-3 gap-6">
              {data?.images?.map((img, index) => (
                <div key={index}>
                  <label className="block text-sm text-neutral-700 mb-2">
                    Story Image {index + 1}
                  </label>
                  <div className="border-2 border-dashed border-neutral-300 rounded-md p-6 flex flex-col items-center justify-center h-64">
                    <div className="w-full h-full rounded-md flex items-center justify-center text-white text-sm overflow-hidden">
                      {img ? (
                        <img
                          src={getImageSrc(img)}
                          alt={`story-${index}`}
                          className="w-full h-full object-cover rounded-md"
                        />
                      ) : (
                        "Company History Photo"
                      )}
                    </div>

                    {/* File input */}
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;

                        const updatedImages = [...data.images];
                        updatedImages[index] = file;
                        setData({ ...data, images: updatedImages });
                      }}
                      className="hidden"
                      id={`promiseImage-${index}`}
                    />

                    <label
                      htmlFor={`promiseImage-${index}`}
                      className="px-3 py-1 border border-neutral-300 rounded-md text-sm cursor-pointer mt-2"
                    >
                      Change Image
                    </label>
                  </div>
                  <span className='text-sm font-medium text-gray-700'>Recomended Image Size : 800px*600px</span>
                </div>
              ))}
            </div>

          </div>
          <div className="flex justify-end space-x-3 mt-8">
            <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
              onClick={() => navigate(-1)}
            >Cancel</button>
            <button
              className="px-4 py-2 bg-neutral-900 text-white rounded-md"
              onClick={() => handleSubmit()}
            >
              Save Promise
            </button>
          </div>
        </div>
      </Loader>
    </div>
  )
}

export default Ourpromise
